import React from 'react';
import styled from 'styled-components';
import useTheme from '@material-ui/core/styles/useTheme';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import FollowButton from '../../../Businesses/Follow/FollowButton';

const Wrapper = styled.div<{ theme: Theme }>`
  margin-top: auto;
  margin-left: auto;
  ${({ theme }) =>
    `${theme.breakpoints.only('xs')} {
      margin-top: 30px;
      margin-right: auto;
      width: 100%;
      text-align: center;
    }
  `};
  ${({ theme }) =>
    `${theme.breakpoints.up('sm')} {
      min-width: 210px;
    }
 `};
`;

interface Props {
  id: number;
  name: string;
  businessSiteId?: number | null;
}

const Button = ({ id, name, businessSiteId }: Props) => {
  const theme = useTheme();
  return (
    <Wrapper theme={theme}>
      <FollowButton
        businessId={id}
        businessName={name}
        businessSiteId={businessSiteId}
        isFollowing
        isAuthenticated
      />
    </Wrapper>
  );
};

export default Button;
